import React from 'react';
// import { useAppLanguage } from '../../../hooks'
import { Toolbar, Typography } from '@material-ui/core';
import UserProfileMenu from '../UserProfileMenu';
import './AppBarContent.scss';

const defaultJwtUserInfo = JSON.stringify({
    FirstName: '',
    LastName: '',
    FullName: '',
});

/**
 * @param {{
 *  name: string,
 *  pageName?: string,
 *  onNameClick?: () => void,
 *  sidebarIcon?: *,
 * }} param0
 */
const AppBarContent = ({
    name,
    pageName = '',
    onNameClick,
    sidebarIcon,
}) => {
    /** @type {CommonClient2.IUserInfo} */
    const jwtUserInfo = JSON.parse(sessionStorage.getItem('jwtUserInfo') || defaultJwtUserInfo);
    const { FullName } = jwtUserInfo;
    const initials = sessionStorage.getItem('userInitials') || '';
    const pointerClass = typeof (onNameClick) === 'function' ? 'pointing' : '';
    const configs = {
        appEnvironment: sessionStorage.getItem('appEnvironment') || '',
        appVersion: sessionStorage.getItem('version') || '',
        isMultiLanguage: JSON.parse(sessionStorage.getItem('isMultiLanguage') || 'false'),
    };

    // const { changeLanguage, currentLanguage } = useAppLanguage();

    return (
        <Toolbar className="core--app-bar-content">
            {!!sidebarIcon && sidebarIcon}
            <div
                className={`core--app-bar-left-content ${pointerClass}`}
                onClick={onNameClick}
            >
                <div>
                    {pageName && <span className="headline-h-500">{pageName}</span>}
                    {name && <span className="text-sm-regular">{name}</span>}
                </div>
            </div>
            <div className="core--app-bar-right-content">
                <Typography variant="subtitle2">{process.env.REACT_APP_VERSION}</Typography>
                <UserProfileMenu
                    fullName={FullName}
                    initials={initials}
                    // onChangeLanguage={changeLanguage}
                    // currentLanguage={currentLanguage}
                    configs={configs}
                />
            </div>
        </Toolbar>
    );
};

export default AppBarContent;
